import { render } from "./breadCrumbs.vue?vue&type=template&id=4d46866f"
import script from "./breadCrumbs.vue?vue&type=script&lang=js"
export * from "./breadCrumbs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__